import Icon from '@amzn/meridian/icon';
import { useTheme as useMeridianTheme } from '@amzn/meridian/theme';
import viewFilledIconTokens from '@amzn/meridian-tokens/base/icon/view-filled';
import { css } from '@emotion/css';
import meridianOrangePalette from '../theme/meridian-orange';

export default function SidebarBrand() {
  const meridianTheme = useMeridianTheme();

  const lockupClass = css({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: 0,
  });
  const markTileClass = css({
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
    borderRadius: 8,
    backgroundColor: meridianOrangePalette.palette400,
    color: '#ffffff',
  });
  const wordmarkClass = css({
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  });
  const productNameClass = css({
    color: meridianTheme('themeInkDefault'),
    fontSize: 14,
    fontWeight: 650,
    letterSpacing: '-0.01em',
    lineHeight: '18px',
    whiteSpace: 'nowrap',
  });
  const platformNameClass = css({
    color: meridianTheme('themeInkSubdued'),
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.06em',
    lineHeight: '14px',
    textTransform: 'uppercase',
  });

  return (
    <span className={lockupClass}>
      <span className={markTileClass}>
        <Icon tokens={viewFilledIconTokens} />
      </span>
      <span className={wordmarkClass}>
        <span className={platformNameClass}>IRIS</span>
        <span className={productNameClass}>MCP Spec Catalog</span>
      </span>
    </span>
  );
}
